// Campaign consent input type
export const CONSENT_INPUT_TYPE = Object.freeze({
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
})

// Campaign consent requirement
export const CONSENT_REQUIREMENT = Object.freeze({
  OPTIONAL: 'optional',
  MUST_ANSWER: 'must_answer',
  MUST_ACCEPT: 'must_accept',
})

// Reason returned by the API when a required consent is not answered
export const CONSENT_ERROR_REASON = Object.freeze({
  MISSING: 'missing',
  NOT_ACCEPTED: 'not_accepted',
})

// Choices of a radio consent
export const CONSENT_CHOICE_OPTIONS = Object.freeze([
  { label: 'ยินยอม', value: true },
  { label: 'ไม่ยินยอม', value: false },
])

export const CONSENT_ERROR_MESSAGE = Object.freeze({
  MISSING_RADIO: 'กรุณาเลือกคำตอบสำหรับเงื่อนไขนี้',
  MISSING_CHECKBOX: 'กรุณายอมรับเงื่อนไขนี้',
  NOT_ACCEPTED: 'กรุณายอมรับเงื่อนไขนี้เพื่อดำเนินการต่อ',
})
